import { render, staticRenderFns } from "./LayoutUser.vue?vue&type=template&id=27bad58f"
import script from "./LayoutUser.vue?vue&type=script&lang=js"
export * from "./LayoutUser.vue?vue&type=script&lang=js"
import style0 from "./LayoutUser.vue?vue&type=style&index=0&id=27bad58f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports